<section class="w3l-form-25">
    <div class="form-inner-cont">
        <div class="w3l-form-25">
            <h1>Unit of Measure Master Data</h1>
            <p>Enter unit of measure daster data below to stay updated </p>
        </div>
    </div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>

        </div>
    </div>
</section>
<div id="w3l-appointment">
    <section class="appointment-section section-gap">
        <div class="wrapper">
            <div class="d-grid doctor-appointment">
                <div class="appointment-form">
                    <form action="#" method="post">
                        <div class="fields-grid">

                            <div class="styled-input">
                                <label>Unit ID</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-search" aria-hidden="true" (click)="openDialogs()" style="cursor: grab;"></span>
                                    <input type="text" name="UnitId"  id="UnitId" placeholder="Unit ID" maxlength="3ch" [(ngModel)]="unCode" (change)="retriveUnits()" style="width: 30%;">
                                </div>
                            </div>
                            <div class="styled-input">
                                <label>Unit Name</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-edit" aria-hidden="true"></span>
                                    <input type="text" name="Unitname" placeholder="Full Name" maxlength="50ch" [(ngModel)]="unName" required="">

                                </div>
                            </div>
                            <div class="styled-input">
                              <label>Arabic Name</label>
                              <div class="appointment-form-field">
                                  <span class="fa fa-edit" aria-hidden="true"></span>
                                  <input type="text" name="UnitArabicname" placeholder="Full Name" maxlength="50ch" [(ngModel)]="unArName" required="">

                              </div>
                          </div>
                            <div class="styled-input">
                                <label>Unit each</label>
                                <div class="appointment-form-field">
                                    <span class="fa fa-map" aria-hidden="true"></span>
                                    <input type="text" name="each" style="width: 30%;" placeholder="00.00" value = "1" [(ngModel)]="unrach" required="">
                                </div>
                            </div>
                            <button type="button" class="theme-button btn" (click)="submitUnits()" name="submit">Submit</button>
                            <button type="button" class="theme-button btn" (click)="mesgDelete()" name="Delete">Delete</button>
                            <button type="button" class="theme-button btn" (click)="NewData()" name="New">New</button>
                            <a href="Home">
                                <button type="button" class="theme-button btn" style="width: 83%;"
                                    name="Back">Home</button>
                            </a>
                            <div class="clear"> </div>
                        </div>
                    </form>
                </div>

                <div class="registerimg">
                    <div class="clear"> </div>
                    <img src="assets/images/unit-of-measurement.jpg" alt="" />
                </div>
            </div>
            <div class="clear"> </div>
        </div>
    </section>
</div>
